var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VendorDetailLayout',{attrs:{"type":"suggestion","id":_vm.id,"listPage":"experiences","moduleName":"experiences"}})
}
var staticRenderFns = []

export { render, staticRenderFns }